<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        Theoretically, what volume of hydrogen gas at
        <number-value :value="temp" unit="^{\circ}\text{C}" />
        and
        <number-value :value="pressure" unit="\text{torr}" />
        is produced in the reaction of
        <number-value :value="massAl" unit="\text{g}" />
        of
        <chemical-latex content="Al" />
        metal with an excess of hydrochloric acid to produce
        <chemical-latex content="AlCl3" />
        and
        <chemical-latex content="H2?" />
        <b>Hint.</b> You may want to write a balanced equation first.
      </p>

      <calculation-input
        v-model="inputs.studentAnswer"
        prepend-text="$\text{Volume:}$"
        append-text="$\text{mL}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'OleMiss116Post2_Q2part1',
  components: {
    ChemicalLatex,
    CalculationInput,
    NumberValue,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        studentAnswer: null,
      },
    };
  },
  computed: {
    temp() {
      return this.taskState.getValueBySymbol('temp').content;
    },
    pressure() {
      return this.taskState.getValueBySymbol('pressure').content;
    },
    massAl() {
      return this.taskState.getValueBySymbol('massAl').content;
    },
  },
};
</script>
